import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { OrdersSession } from "@/shared/v2/queries/interfacesV2";
import { useQuery } from "@tanstack/react-query";

const useActiveOrdersSessionsQuery = () => {
  const branch = useBranchId();
  const queryKey = ["ordersSessions", "active", "order", branch];
  const query = useQuery<OrdersSession[]>({
    queryKey: queryKey,
    queryFn: () =>
      get2(`/internal/secure/pos/v1/order/sessions/active/all/${branch}`),
    enabled: branch > 0,
  });
  return query;
};

export default useActiveOrdersSessionsQuery;
